import { render, staticRenderFns } from "./allSubscription.vue?vue&type=template&id=54b7bbd8&scoped=true"
import script from "./allSubscription.vue?vue&type=script&lang=js"
export * from "./allSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7bbd8",
  null
  
)

export default component.exports